import { PlanType } from '@prisma/client';

export interface Features {
  // Put features here
  // Analytics: boolean;
  // AnalyticsDateFiltering: boolean;
  // SessionAnalytics: boolean;
  // OverlayForm: boolean;
  // OverlayModal: boolean;
  // HTML: boolean;
  // RemoveWatermark: boolean;
  // CustomBranding: boolean;
  // Variables: boolean;
  // CustomFonts: boolean;
  // Theme: boolean;
  // Integrations: boolean;
  API: boolean;
  // Blur: boolean;
  // CustomizableBrowser: boolean;
  // CTAOptions: boolean;
  // Checklist: boolean;
  // IntegrateVideos: boolean;
  // ConnectCalendar: boolean;
  // EmailIntegrations: boolean;
  // PasswordProtection: boolean;
  // LinkExpiration: boolean;
  // CustomLinks: boolean;
  // CustomDomain: boolean;
  // VisitorsRecognition: boolean;
  SharedFolders: boolean;
  // AdvancedTeamRoles: boolean;
  // The flag should be taken from custom plans
  SSO: boolean;
  // GIF: boolean;
  // Video: boolean;
  // Integrations
  // IntegrationSalesforce: boolean;
  // IntegrationHubspot: boolean;
  // IntegrationPipedrive: boolean;
  // IntegrationRestHook: boolean;
  // IntegrationSlack: boolean;
  // IntegrationSegment: boolean;
  // IntegrationMixpanel: boolean;
  // IntegrationGoogleAnalytics: boolean;
  // IntegrationOneTrust: boolean;
}

export type Feature = keyof Features;

export const plansOrder: PlanType[] = [PlanType.Free, PlanType.Start, PlanType.Pro, PlanType.Enterprise];
